import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";

export const ConditionBox = styled(FlexDiv)`
  margin: 0 -8px;
  flex-wrap: wrap;
  @media only screen and (max-width: 1079px) {
    padding: 0 8px;
  }
  @media only screen and (max-width: 992px) {
    margin: 0 -4px;
  }
`;
export const ConditionTitle = styled(Typography)`
  @media only screen and (max-width: 1079px) {
    flex: 1;
  }
`;
export const ConditionItem = styled(FlexDiv)`
  width: 100%;
  position: relative;
  cursor: pointer;
  max-width: calc(20% - 16px);
  user-select: none;
  margin: 0 8px 16px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  & * {
    transition: all 0.3s ease-in-out;
  }
  border: 2px solid
    ${({ theme, isActive }) =>
      isActive
        ? theme.colorsV2.shyft.purple_text
        : theme.colorsV2.blueGray.shade_100};
  border-radius: 32px;
  ${ConditionTitle} {
    color: ${({ theme, isActive }) =>
      isActive
        ? theme.colorsV2.primary.shade_800
        : theme.colorsV2.gray.shade_800};
  }
  @media only screen and (max-width: 1079px) {
    max-width: calc(25% - 16px);
    border-radius: 16px;
    padding: 16px 16px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  @media only screen and (max-width: 992px) {
    max-width: calc(33.33% - 8px);
    margin: 0 4px 8px;
  }
  @media only screen and (max-width: 767px) {
    max-width: calc(50% - 8px);
  }
  @media only screen and (max-width: 399px) {
    padding: 16px 8px;
  }
`;
export const ImageHolder = styled(Image)``;
export const ImageBox = styled(FlexDiv)`
  margin-bottom: 8px;
  height: 32px;
  width: 32px;
  ${ImageHolder} {
    height: 100%;
    width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  @media only screen and (max-width: 1079px) {
    margin-bottom: 0;
    min-width: 32px;
    margin-right: 8px;
  }
`;
export const SelectedIcon = styled(StyledSvgSprite)`
  position: absolute;
  top: 17px;
  right: 21px;
  height: 32px;
  width: 32px;
  fill: ${({ theme }) => theme.colorsV2.success.shade_600};
  @media only screen and (max-width: 1079px) {
    top: 2px;
    transform: none;
    right: 2px;
    height: 24px;
    width: 24px;
  }
`;
